import { PulseIcon } from './PulseIcon';

/**
 * author: Austin Andrews
 * id 2A0F7B5D-5D23-4E76-B97D-9D2281D3C4EA
 * name pulse
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pulse.svg
 * tags
 * - Medical / Hospital 
 */
export const VitalsIcon = PulseIcon;
export default VitalsIcon